/* eslint-disable no-return-await, no-console, no-param-reassign, no-trailing-spaces */
import axios from 'axios';
import moment from 'moment';
import helper from '@/_libs/helper';
import salesUser from '../_user';
// import order from '../_order';

const DATE_TODAY = moment().format('YYYY-MM-DD');

const DATE_YESTERDAY = moment().subtract(1, 'days').format('YYYY-MM-DD');
const DATE_3_DAYS_AGO = moment().subtract(3, 'days').format('YYYY-MM-DD');
const DATE_LASTWEEK = moment().subtract(7, 'days').format('YYYY-MM-DD');

// const DATE_TOMORROW = moment().add(1, 'days').format('YYYY-MM-DD');

const MOCK = {
  user: {
    current: {
      name: 'ณัฐพนธ์ เชาวนศิลป',
      firstName: 'ณัฐพนธ์',
      lastName: 'เชาวนศิลป',

      id: '011023',
      code: '08594111',
      zone: 'NE',

      email: 'someone@example.com',
      phone: '08594333211',

      username: 'xxxxx',
      imgSrc: 'http://placekitten.com/128/128',

      stat: {
        pendingOrder: {
          count: 54,
          total: 596800.50,
        },
        unpaid: {
          count: 99,
          total: 30004459,
        },
        backOrder: {
          count: 10,
          total: 600780.5,
        },
        awaitShipment: {
          count: 34,
          total: 7567000,
        },
      },
    },
    pendingOrderList: [
      {
        id: 1,
        dueDate: DATE_TODAY,
        customerName: 'บริษัท เอส 11 กรุ๊ป จำกัด (มหาชน)',
        total: 69000.46,
        sellDate: DATE_LASTWEEK,
      },
      {
        id: 2,
        dueDate: DATE_TODAY,
        customerName: 'บริษัท เอส 11 กรุ๊ป จำกัด (มหาชน)',
        total: 69000.46,
        sellDate: DATE_LASTWEEK,
      },
      {
        id: 3,
        dueDate: DATE_TODAY,
        customerName: 'บริษัท เอส 11 กรุ๊ป จำกัด (มหาชน)',
        total: 69000.46,
        sellDate: DATE_3_DAYS_AGO,
      },
    ],
    unpaidList: [
      {
        id: 0,
        dueDate: DATE_3_DAYS_AGO,
        customerName: 'บริษัท เอส 11 กรุ๊ป จำกัด (มหาชน)',
        total: 69000.46,
        sellDate: DATE_LASTWEEK,
      },
      {
        id: 1,
        dueDate: DATE_3_DAYS_AGO,
        customerName: 'บริษัท เอส 11 กรุ๊ป จำกัด (มหาชน)',
        total: 69000.46,
        sellDate: DATE_LASTWEEK,
      },
      {
        id: 2,
        dueDate: DATE_YESTERDAY,
        customerName: 'บริษัท เอส 11 กรุ๊ป จำกัด (มหาชน)',
        total: 12453.46,
        sellDate: DATE_3_DAYS_AGO,
      },
      {
        id: 3,
        dueDate: DATE_YESTERDAY,
        customerName: 'บริษัท เอส 11 กรุ๊ป จำกัด (มหาชน)',
        total: 69000.46,
        sellDate: DATE_3_DAYS_AGO,
      },
      {
        id: 4,
        dueDate: DATE_YESTERDAY,
        customerName: 'บริษัท เอส 11 กรุ๊ป จำกัด (มหาชน)',
        total: 9198.46,
        sellDate: DATE_YESTERDAY,
      },
    ],
    backOrderList: [
      {
        id: 1,
        entryNo: 'AB63111205',
        customerName: 'บริษัท เอส 11 กรุ๊ป จำกัด (มหาชน)',
        total: 69000.46,
        date: DATE_LASTWEEK,
      },
      {
        id: 2,
        entryNo: 'AB63111206',
        customerName: 'บริษัท เอส 11 กรุ๊ป จำกัด (มหาชน)',
        total: 69000.46,
        date: DATE_3_DAYS_AGO,
      },
      {
        id: 3,
        entryNo: 'AB63111207',
        customerName: 'บริษัท เอส 11 กรุ๊ป จำกัด (มหาชน)',
        total: 69000.46,
        date: DATE_YESTERDAY,
      },
      {
        id: 4,
        entryNo: 'AB63111210',
        customerName: 'บริษัท เอส 11 กรุ๊ป จำกัด (มหาชน)',
        total: 69000.46,
        date: DATE_TODAY,
      },
    ],
    awaitShipmentList: [
      {
        id: 1,
        entryNo: 'AB63111205',
        customerName: 'บริษัท เอส 11 กรุ๊ป จำกัด (มหาชน)',
        total: 69000.46,
        sellDate: DATE_3_DAYS_AGO,
      },
      {
        id: 2,
        entryNo: 'AB63111206',
        customerName: 'บริษัท เอส 11 กรุ๊ป จำกัด (มหาชน)',
        total: 69000.46,
        sellDate: DATE_YESTERDAY,
      },
      {
        id: 3,
        entryNo: 'AB63111207',
        customerName: 'บริษัท เอส 11 กรุ๊ป จำกัด (มหาชน)',
        total: 69000.46,
        sellDate: DATE_TODAY,
      },
      {
        id: 4,
        entryNo: 'AB63111210',
        customerName: 'บริษัท เอส 11 กรุ๊ป จำกัด (มหาชน)',
        total: 69000.46,
        sellDate: DATE_TODAY,
      },
    ],

    profilePerformance: {
      bestSellings: [
        { id: '01', name: 'ไม้อัดพิเศษ', total: 69000.46 },
        { id: '02', name: 'ไม้อัดธรรมดา', total: 69000.46 },
        { id: '03', name: 'ไม้แปรรูป', total: 69000.46 },
        { id: '04', name: 'กระดาษอัด', total: 69000.46 },
        { id: '05', name: 'ประตู', total: 6659.0 },
        { id: '06', name: 'บอร์ดหนา', total: 5512.0 },
        { id: '07', name: 'บอร์ดเคลือบ/ไฟเมก้า', total: 4320.0 },
        { id: '08', name: 'ลวด', total: 3319.0 },
        { id: '09', name: 'ตะปู/ตะขอ', total: 0 },
        { id: '10', name: 'สังกะสี/โลหะแปรรูป', total: 0 },
        { id: '11', name: 'อลูมีเนียม/อุปกรณ์', total: 0 },
        { id: '12', name: 'ซีไลน์/เหล็กขึ้นรูป', total: 0 },
        { id: '13', name: 'เคมี/น้ำยา', total: 0 },
        { id: '99', name: 'เบ็ดเตล็ด', total: 0 },
      ],
    },
  },
};

const user = {
  async current() {
    return await helper.call('cs.user.myProfile', {
      success: true,
      data: MOCK.user.current,
    }, async () => {
      const res = await salesUser.myProfile();
      // const statRes = await salesUser.goalDashboard();

      const { data } = res;
      // const stat = statRes.data;

      res.data = {
        ...data,
        zone: data.area ? data.area.name : '-',

        // TODO: change to real API data
        stat: {
          pendingOrder: { count: '...', total: 0 },
          outstanding: { count: '...', total: 0 },
          backOrder: { count: '...', total: 0 },
          awaitShipment: { count: '...', total: 0 },
        },

        // performance: {
        //   today: {
        //     sales: stat.today.total_sale,
        //     commissions: stat.today.total_commission,
        //   },
        //   thisMonth: {
        //     sales: stat.month.total_sale,
        //     goal: stat.month.goal,
        //   },
        // },
      };
      return res;
    });
  },

  // Dashboard
  async pendingOrderList() {
    return await helper.call('cs.user.pendingOrderList', {
      success: true,
      data: MOCK.user.pendingOrderList,
    }, async () => await axios(helper.path('cs/user/pending-order-list')));
  },
  async unpaidList() {
    return await helper.call('cs.user.unpaidList', {
      success: true,
      data: MOCK.user.unpaidList,
    }, async () => await axios(helper.path('cs/user/unpaid-list')));
  },
  async backOrderList() {
    return await helper.call('cs.user.backOrderList', {
      success: true,
      data: MOCK.user.backOrderList,
    }, async () => await axios(helper.path('cs/user/backorder-list')));
  },
  // async awaitShipmentList(page = 1, from = undefined, to = undefined) {
  //   return order.list('submitted', page, from, to, undefined, undefined, true);
  // },

  // ProfilePerformance
  async recentSalesList() {
    return await helper.call('user.recentSalesList', {
      success: true,
      data: MOCK.user.awaitShipmentList,
    }, async () => await axios(helper.path('user/recent-sales-list')));
  },
  // async bestSellingsList() {
  //   return await helper.call('user.bestSellingsList', {
  //     success: true,
  //     data: MOCK.user.profilePerformance.bestSellings,
  //   }, async () => await axios(helper.path('user/best-sellings-list')));
  // },
};

export default user;
